import * as type from './types'
import actions from './actions'
import getters from './getters'
import Vue from 'vue'
import fx from 'money'


const state = {
  shipmentDaysList: null,
  isFetching: false,
  selectedShipment: null,
  isSelecting: false,
  toggledShipments: [],
  errors: null,
  lastDay: null,
  lastUrl: null,
  total: 0,
  ranges: null,
  selectedView: 'overview',
  exchangeRates: null
}
const initialState = {
  shipmentDaysList: null,
  isFetching: false,
  selectedShipment: null,
  isSelecting: false,
  toggledShipments: [],
  errors: null,
  lastDay: null,
  lastUrl: null,
  total: 0,
  ranges: null,
  selectedView: 'overview',
  exchangeRates: null
}

const mutations = {
  [type.SET_SHIPMENTS_GROUPBYDAY_LIST](state, action) {
    state.shipmentDaysList = action.items
  },
  [type.UPDATE_SHIPMENTS_GROUPBYDAY_LIST](state, action) {
    state.shipmentDaysList = [ ...state.shipmentDaysList, ...action.items ]
  },
  [type.SET_SHIPMENTS_GROUPBYDAY_LAST_DAY](state, action) {
    state.lastDay = action.lastDay
  },
  [type.SET_SHIPMENTS_GROUPBYDAY_TOTAL](state, action) {
    state.total = action.total
  },
  [type.SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING](state, action) {
    state.isFetching = action.flag
  },
  [type.SET_TOGGLE_SHIPMENT](state, action) {
    const index = state.toggledShipments.indexOf(action.shipmentID)
    if (index < 0) {
      state.toggledShipments.push(action.shipmentID)
    }
  },
  [type.REMOVE_TOGGLE_SHIPMENT](state, action) {
    const index = state.toggledShipments.indexOf(action.shipmentID)
    if (index >= 0) {
      state.toggledShipments.splice(index, 1)
    }
  },
  [type.SET_TOGGLE_DAY](state, action) {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) =>  action.date === date)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        state.shipmentDaysList[dayIndex].shipments.forEach(({ id }) => {
          const index = state.toggledShipments.indexOf(id)
          if (index < 0) {
            state.toggledShipments.push(id)
          }
        })
      }
    }
  },
  [type.REMOVE_TOGGLE_DAY](state, action) {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) =>  action.date === date)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        state.shipmentDaysList[dayIndex].shipments.forEach(({ id }) => {
          const index = state.toggledShipments.indexOf(id)
          if (index >= 0) {
            state.toggledShipments.splice(index, 1)
          }
        })
      }
    }
  },
  [type.SET_SHIPMENTS_GROUPBYDAY_ERRORS](state, action) {
    state.errors = action.error
  },
  [type.REMOVE_SHIPMENTS_GROUPBYDAY_ERRORS](state) {
    state.errors = null
  },
  [type.SET_SELECTED_VIEW](state, action) {
    state.selectedView = action.view
  },
  [type.SET_SHIPMENTS_GROUPBYDAY_RANGES] (state, action) {
    // Check if i have some range attribute from before and update it
    // If data array length is 0 then im getting ranges array empty, so i need to set range from, to to 0
    if (state.ranges != null) {
      let oldState = [...state.ranges]
      oldState.forEach((rangeObject, stateRangeIndex) => {
        const index = action.ranges.findIndex(({ type }) => {
          return type === rangeObject.type
        })
        if (index >= 0) {
          oldState[stateRangeIndex] = { ...oldState[stateRangeIndex], ...action.ranges[index]}
        } else {
          oldState[stateRangeIndex] = { ...oldState[stateRangeIndex], from: 0, to: 0}
        }
      })
      state.ranges = oldState
    } else {
      state.ranges = action.ranges
    }
  },
  [type.SET_LAST_URL] (state, action) {
    state.lastUrl = action.url
  },
  [type.UPDATE_SELECTED_SHIPMENT_CARD](state, action) {
    if (state.shipmentDaysList != null) {
      const findShipmentDayIndex = state.shipmentDaysList.findIndex(({ shipments }) => {
        return shipments.findIndex(({ id }) => id === action.shipment.id) >= 0
      })
      if (findShipmentDayIndex >= 0) {
        Vue.set(state.shipmentDaysList, findShipmentDayIndex, action.day )
      }
    }
  },
  [type.UPDATE_SELECTED_SHIPMENT_CARD_LABELS](state, action) {
    const findShipmentDayIndex = state.shipmentDaysList.findIndex(({ shipments }) => {
      return shipments.findIndex(({ id }) => id === action.shipment.id) >= 0
    })
    if (findShipmentDayIndex >= 0) {
      let findShipmentDay = state.shipmentDaysList[findShipmentDayIndex]
      const findShipmentIndexInDay = findShipmentDay.shipments.findIndex(({ id }) => {
        return id === action.shipment.id
      })
      findShipmentDay.shipments[findShipmentIndexInDay] = {...findShipmentDay.shipments[findShipmentIndexInDay], labels: action.labels}
      Vue.set(state.shipmentDaysList, findShipmentDayIndex, findShipmentDay )
    }
  },
  [type.SET_EXCHANGE_RATES] (state, action) {
    state.exchangeRates = action.exchangeRates
  },
  [type.SET_RESET_STATE] (state) {
    Object.assign(state, initialState)
  }
}

export const shipmentsGroupByDay = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
